// initial state
import { guest } from '../../plugin/axios'
export default{
  namespaced:true,

 state:{
    makes: [],
    make: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null,
    
},
 mutations:{
    setMakes: (state, makes) => {
        state.makes = makes
    },
    setMakeDetail: (state, make) => {
        state.make = make
    },
    saveNewMakes: (state, make) => {
        state.makes.unshift(make)
        state.createdData = make
    },
    saveUpdatedMake: (state, make) => {
        // Find index
        // state.makes.unshift(make)
        state.updatedData = make
        const index = state.makes.findIndex(
            (make) => make.id === state.updatedData.id
        )
        if (index !== -1) {
            state.makes.splice(index, 1, state.updatedData)
        }
    },
    setDeleteMake: (state, id) => {
        const index = state.makes
            .map((x) => {
                return x.id
            })
            .indexOf(id)
        state.makes.splice(index, 1)
    },
    setMakeIsLoading(state, isLoading) {
        state.isLoading = isLoading
    },
    setMakeIsCreating(state, isCreating) {
        state.isCreating = isCreating
    },
    setMakeIsUpdating(state, isUpdating) {
        state.isUpdating = isUpdating
    },
    setMakeIsDeleting(state, isDeleting) {
        state.isDeleting = isDeleting
    },
},
actions:{
    async fetchAllMakes({ commit }) {
        commit('setMakeIsLoading', true)
        await guest
            .get('/makes')
            .then((res) => {
                if (res.data === null) {
                    commit('setMakeIsLoading', false)
                    this.$toast.error(
                        'Dublicate Entry!,The make Has been Registered Before Now!!'
                    )
                }
                const makes = res.data.make
                commit('setMakes', makes)
                commit('setMakeIsLoading', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('An Error Occured !!!')
                    commit('setMakeIsLoading', false)
                }
            })
    },
    async storeMake({ commit }, make) {
        commit('setMakeIsCreating', true)
        await guest
            .post('/makes-store', make)
            .then((res) => {
                if (res.data === null) {
                    commit('setMakeIsLoading', false)
                    this.$toast.error(
                        'Dublicate Entry!,The make Has been Registered Before Now!!'
                    )
                } else {
                    commit('saveNewMakes', res.data.make)
                    commit('setMakeIsCreating', false)
                }
            })
            .catch((err) => {
                if (err.response.status === 500) {
                    commit('setMakeIsCreating', false)
                    this.$toast.error(
                        'Dublicate Entry!,The make Has been Registered Before Now!!'
                    )
                }
            })
    },
    async fetchDetailMake({ commit }, id) {
        commit('setMakeIsLoading', true)
        await guest
            .get(`makes-show/${id}`)
            .then((res) => {
                commit('setMakeDetail', res.data.make)
                commit('setMakeIsLoading', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Field Not Properly Field')
                    commit('setMakeIsLoading', false)
                }
            })
    },
    async updateMake({ commit }, make) {
        commit('setMakeIsUpdating', true)
        await guest
            .post(`makes-update/${make.id}`, make)
            .then((res) => {
                commit('saveUpdatedMake', res.data.make)
                commit('setMakeIsUpdating', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Fields not properly filled')
                    commit('setMakeIsUpdating', false)
                } else if (err.response.status === 500) {
                    this.$toast.error(
                        'Dublicate Entry!,The make Has been Registered Before Now!!'
                    )
                    commit('setMakeIsUpdating', false)
                }
            })
    },
    async deleteMake({ commit }, id) {
        commit('setMakeIsDeleting', true)
        await guest
            .delete(`makes-delete/${id}`)
            .then((res) => {
                commit('setDeleteMake', res.data.make.id)
                commit('setMakeIsDeleting', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Field Not Properly Filled')
                    commit('setMakeIsDeleting', false)
                }
            })
    },
},
getters:{
    makeList: (state) => state.makes,
    make: (state) => state.make,
    isLoadingMake: (state) => state.isLoading,
    isCreating: (state) => state.isCreating,
    isUpdating: (state) => state.isUpdating,
    createdData: (state) => state.createdData,
    updatedData: (state) => state.updatedData,
    isDeleting: (state) => state.isDeleting,
    deletedData: (state) => state.deletedData,
},
}